var React = require('react');

function TableCheckMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 7L7.66667 14L21 1","stroke":"#F45C25","strokeWidth":"2"}));
}

TableCheckMark.defaultProps = {"width":"22","height":"16","viewBox":"0 0 22 16","fill":"none"};

module.exports = TableCheckMark;

TableCheckMark.default = TableCheckMark;
